import { defineComponent, h } from 'vue';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

// Register necessary components from Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default defineComponent({
  name: 'App',
  components: {
    Bar
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: {
        indexAxis: 'y', // This changes the orientation of the chart to horizontal
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            position: 'bottom',
            padding: 25,
            labels: {
              font: {
                // Additional font properties can be specified if needed
              }
            }
          },
          tooltip: {
            callbacks: {
              title: () => "",
              label: function(context) {
                let label = context.dataset.label || '';
                let label2 = '';
                let index = context.dataIndex;

                if (label) {
                  label += ': ';
                }

                if (context.parsed.x !== null) {
                  label += context.dataset.tooltips[index];
                  label2 += context.parsed.x.toLocaleString() + context.dataset.currencies[index];
                }

                if (context.dataset.tooltips[index] === "") {
                  return [label2];
                } else {
                  return [label, label2];
                }
              }
            }
          },
          datalabels: {
            display: false // Disable data labels on bars
          }
        },
        scales: {
          y: {
            position: 'left',
            grid: {
              display: true,
              color: "#e4e6e8",
            },
            ticks: {
              maxTicksLimit: 20,
              font: {
                size: 10
              },
            }
          },
          x: {
            grid: {
              display: false
            },
            ticks: {
              font: {
                size: 10
              },
              maxRotation: 0,
              minRotation: 0,
            }
          }
        }
      }
    };
  },
  render() {
    return h('div', { style: { height: '400px' } }, [
      h(Bar, {
        data: this.chartData,
        options: this.options
      })
    ]);
  }
});
